import { Save } from 'lucide-react';

interface LastSavedIndicatorProps {
  lastSavedAt: Date | null;
  isSaving: boolean;
  hasUnsavedChanges: boolean;
}

export const LastSavedIndicator = ({
  isSaving,
  hasUnsavedChanges,
}: LastSavedIndicatorProps) => {
  // Only show the icon when there are unsaved changes or actively saving
  // Hide completely after save completes
  if (!isSaving && !hasUnsavedChanges) {
    return null;
  }

  return (
    <div className="flex items-center" title={isSaving ? "Saving..." : "Unsaved changes"}>
      <Save className={`w-4 h-4 ${isSaving ? 'animate-pulse text-blue-500' : 'text-amber-500'}`} />
    </div>
  );
};
